import { render } from "./pitch.vue?vue&type=template&id=c02e8c8c&scoped=true"
import script from "./pitch.vue?vue&type=script&lang=js"
export * from "./pitch.vue?vue&type=script&lang=js"

import "./pitch.vue?vue&type=style&index=0&id=c02e8c8c&scoped=true&lang=css"

import exportComponent from "/var/lib/buildkite-agent/builds/BKxAWS-i-0add72b42d7a2609c-1/assemble-sports/unisports-livescores-production-vertical-traffic-light/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c02e8c8c"]])

export default __exports__